import React from 'react';
import { motion } from 'framer-motion';

const ROW1 = [
  'JavaScript', 'React', 'Node.js', 'Next.js', 'Gen AI', 'LLM',
  'RAG', 'LangGraph', 'C#', 'TypeScript', 'Electron', 'REST APIs',
];
const ROW2 = [
  'PostgreSQL', 'MongoDB', 'MySQL', 'Git', 'Material UI', 'HTML/CSS',
  'jQuery', 'Less CSS', 'Vibe Coding', 'Veda AI', 'Audit Logging', 'Form Builder',
];

const MarqueeRow = ({ items, reverse = false }) => {
  const doubled = [...items, ...items];
  return (
    <div className="marquee-outer">
      <div className={`marquee-track${reverse ? ' marquee-track--rev' : ''}`}>
        {doubled.map((item, i) => (
          <span key={i} className="marquee-chip">{item}</span>
        ))}
      </div>
    </div>
  );
};

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55 } },
};

const Skills = () => (
  <section id="skills" className="section skills-section">
    <div className="section-inner">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-80px' }}
        variants={{ visible: { transition: { staggerChildren: 0.1 } } }}
      >
        <motion.p className="section-label" variants={fadeUp}>Toolkit</motion.p>
        <motion.h2 className="section-title" variants={fadeUp}>
          Skills &amp; Technologies
        </motion.h2>
      </motion.div>
    </div>

    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <MarqueeRow items={ROW1} />
      <MarqueeRow items={ROW2} reverse />
    </motion.div>
  </section>
);

export default Skills;
